export const TimelineTypes = Object.freeze({
  MONTH_EVENTS: 'monthEvents',
  WEEK_EVENTS: 'weekEvents',
  OBSERVATIONS: 'Observations',
});
